<template>
  <div class="confer-var">
    <div class="confer-var-form">
      <h3>Upgrade a user to a Value-added Resaler</h3>
      <div class="form-elements">
        <UiSelect
          disable-filter
          has-search
          label="Search by Email"
          :loading="emailSearchLoading"
          :no-results="emailNoResults"
          :options="emailOptions"
          @query-change="onEmailChange"
          :keys="{ label: 'email' }"
          v-model="user"
        >
          <template slot-scope="props" slot="option">
            <div>
              <strong>{{ props.option.email }}</strong>
              <span>{{ props.option.first_name }} {{ props.option.last_name }}</span>
              <div v-if="props.option.org_name">
                Currently at: <em>{{props.option.org_name}}</em>
              </div>
              <div v-if="props.option.last_visit">
                Last visit: <em>{{ relativeTime(props.option.last_visit) }}</em>
              </div>
            </div>
          </template>
        </UiSelect>
        <UiButton
          :loading="loading"
          raised
          @click="conferVAR"
        >
          Give VAR privileges
        </UiButton>
        <div class="message">{{ message }}</div>
        <div class="error" v-show="error">{{ error }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import { UiSelect, UiButton } from 'keen-ui';
import { sleep } from '@/utils';
import { searchUsersByEmail } from '@/store/modules/api';

export default {
  name: 'ConferVAR',
  components: { UiSelect, UiButton },
  data() {
    return {
      emailSearchLoading: null,
      emailSearchError: null,
      emailOptions: [],
      user: null,
      query: null,
      message: null,
    };
  },
  computed: {
    emailNoResults() {
      return !this.emailSearchLoading && this.query && this.emailOptions.length === 0;
    },
    VAR() {
      if (!this.user) return false;
      return _.find(this.vars, { id: this.user.id });
    },
    loading() {
      return this.VAR && this.VAR.loading;
    },
    error() {
      return this.VAR && this.VAR.error;
    },
  },
  methods: {
    relativeTime(ts) {
      return moment(ts).fromNow();
    },
    onEmailChange(query) {
      this.query = query;
      if (query.length === 0) return;
      this.emailSearchLoading = true;
      this.searchUser(query);
    },
    searchUser: _.debounce(async function searchUser(query) {
      this.emailSearchError = null;
      try {
        const { users } = await searchUsersByEmail(query);
        this.emailOptions = users;
      } catch (e) {
        this.emailSearchError = e;
      }
      this.emailSearchLoading = false;
    }, 500),
    async conferVAR() {
      if (!this.user) {
        this.error = 'please choose a user first';
        return;
      }
      await this.$store.dispatch('VARs/addNewVAR', this.user);
      if (!this.error) {
        this.message = 'Success!';
        this.user = null;
        await sleep(4000);
        this.message = null;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.confer-var {
  display: flex;
  flex-direction: column;
  .confer-var-form {
    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
    transition: 0.3s;
    margin-bottom: 30px;
    &:hover {
      box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);
    }
    width: 100%;
    width: fit-content;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex-wrap: wrap;
    padding: 2px 16px;
    > * {
      display: inline-block;
      margin: 10px 20px;
      width: 400px;
    }
    .message {
      height: 20px;
    }
    .error {
      color: red;
    }
    .success {
      color: green;
    }
    .ui-select {
      max-width: 350px;
      margin-left: auto;
      margin-right: auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ConferVAR.vue